import {
  Alert,
  Box,
  Card,
  CardContent,
  Collapse,
  Container,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link as RouterLink } from "react-router-dom-v5-compat";
import Logo from "../../components/Logo";

import { useNavigate } from "react-router-dom-v5-compat";
import useAuth from "../../hooks/useAuth";

export const Wrapper = ({
  title,
  description,
  alert = { severity: "success", message: "" },
  children,
}) => {
  const [showAlert, setShowAlert] = useState(false);

  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) navigate("/dashboard");
  }, [auth.isAuthenticated]);

  useEffect(() => {
    if (alert) {
      if (alert.message.length > 0) {
        setShowAlert(true);

        let timeout = setTimeout(() => setShowAlert(false), 5000);
        return () => clearTimeout(timeout);
      }
    }
  }, [alert]);

  return (
    <>
      <Helmet>
        <title>{title} | MongerTracker GPS Tracking</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Container maxWidth="sm" sx={{ py: "80px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 8,
            }}
          >
            <RouterLink to="/">
              <Logo
                color="black"
                sx={{
                  height: 40,
                  width: 40,
                }}
              />
            </RouterLink>
          </Box>

          <Card>
            <CardContent
              sx={{
                p: 4,
              }}
            >
              <Box
                sx={{
                  py: 1,
                }}
              >
                <Typography color="textPrimary" gutterBottom variant="h4">
                  {title}
                </Typography>
                <Typography color="textSecondary" variant="body2">
                  {description}
                </Typography>
              </Box>

              <Box
                sx={{
                  flexGrow: 1,
                }}
              >
                {children}
              </Box>

              <Collapse in={showAlert}>
                <Box sx={{ mt: 2 }}>
                  <Alert severity={alert?.severity}>{alert?.message}</Alert>
                </Box>
              </Collapse>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </>
  );
};
